import React from "react";

//module imports
import InAppHeader from "../InAppHeader";
import MyInstructorClasses from "./MyInstructorClasses";

function InstructorClassesMain() {
  return (
    <div>
      <InAppHeader />
      <MyInstructorClasses />
    </div>
  );
}

export default InstructorClassesMain;
